var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"iframeContainer",staticClass:"sp_meeting_widget_container"},[_c('iframe',{ref:"iframe",staticClass:"sp_meeting_widget",style:(_vm.iframeStyle),attrs:{"srcdoc":_vm.embedCode}})])
}
var staticRenderFns = []

export { render, staticRenderFns }